var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-link',{staticClass:"pb-3 d-block",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('b-img',{attrs:{"src":require("@/assets/img/ico_back_arrow.svg"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('common.back'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }